import React from "react";
import { createUseStyles } from "react-jss";
import { sendMetriks } from "Services/sendMetriks";
import Button from "ComponentsUI/Button";
import { inject } from "mobx-react";
import { pipe } from "Utils/functionalUtils";
import WhatsappSendMessageContainer from "Containers/WhatsApp/WhatsappSendMessageContainer";

const useStyles = createUseStyles((theme) => ({
	wrapper: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		padding: "30px",
		maxWidth: "380px",
		maxHeight: "680px",
	},
	title: {
		color: theme.palette.colors.purplishBlue,
		fontWeight: 700,
		fontSize: "20px",
		lineHeight: "24px",
		padding: "0",
		margin: "0",
		textAlign: "center",
	},
	descriptionContainer: {
		listStyleType: "none",
		display: "flex",
		flexWrap: "wrap",
		padding: "15px 0 15px",
		gap: "27px",
		marginBlockStart: 0,
		marginBlockEnd: 0,
		paddingInlineStart: 0,
	},
	alertEsim: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: "30px",
		"& svg": {
			flexShrink: 0,
		},
	},
	alertEsimText: {
		fontSize: "12px",
		lineHeight: "14px",
		fontWeight: 700,
		textAlign: "center",
		color: theme.palette.colors.purplishBlue,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		wrapper: {
			maxWidth: "380px",
			flexWrap: "wrap",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		wrapper: {
			maxWidth: "470px",
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		wrapper: {
			maxWidth: "100%",
		},
	},
}));

function VariantTemplate(props) {
	const { children, tariffVariant, alertEsimBlock, linkProps, modalModel } = props;
	const { wrapper, title, descriptionContainer, alertEsim, alertEsimText } = useStyles();
	const { text } = props;

	const closeModal = () => {
		let modalModel = props.modalModel;

		if (modalModel.isOpenMtsConnect) {
			sendMetriks("CLOSE_ESIM_MTS");
			modalModel.toggleModalMtsConnect();
		}
	};

	const openFrameEsim = () => {
		props.closeModalPoPup();
		let promise1 = import("Layouts/modalLayout");
		let promise2 = import("ComponentsUI/Iframes/MtsConnect");
		Promise.all([promise1, promise2]).then((modules) => {
			let ModalLayout = modules[0].default;
			let MtsConnect = modules[1].default;

			modalModel.toggleModalMtsConnect(
				<ModalLayout closeModal={() => closeModal()}>
					<MtsConnect />
				</ModalLayout>
			);
		});
	};
	const onClick = () => {
		sendMetriks("POP_UP_OPERATOR_CLICK_CONNECT");
		if (props.frame) {
			openFrameEsim();
		}
	};

	return (
		<div className={wrapper}>
			<h2 className={title}>{tariffVariant}</h2>
			<ul className={descriptionContainer}>{children}</ul>
			<Button
				fullWidth={true}
				status="purple"
				onClick={onClick}
				component={
					props.frame ? (
						<div>frame</div>
					) : (
						<a target="_blank" rel="noopener noreferrer" href={linkProps}></a>
					)
				}
			>
				{text.CONTINUE}
			</Button>
			<Button
				marginTop={true}
				fullWidth={true}
				status="secondaryAccent"
				onClick={props.clickBackHandler}
			>
				{text.BACK}
			</Button>
			<WhatsappSendMessageContainer
				whatsappType={"pup_up_operator"}
				whatsappSettings={props.ApplicationModel.siteConfig.settings.whatsapp_send_message}
				changeStyle={"pup_up_operator"}
			/>
			{alertEsimBlock && (
				<div className={alertEsim}>
					<svg
						width="30"
						height="30"
						viewBox="0 0 30 30"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="15" cy="15" r="14" stroke="#5812FE" strokeWidth="2" />
						<path
							d="M13.76 17.9L13.56 7.8H16.18L15.98 17.9H13.76ZM13.64 22V19.62H16.1V22H13.64Z"
							fill="#5812FE"
						/>
					</svg>
					<div className={alertEsimText}>{text.VARIANT_TEMPLATE}</div>
				</div>
			)}
		</div>
	);
}

export default pipe(inject("ApplicationModel"))(VariantTemplate);
